import { SERVER_API } from 'config';
// Deep import on purpose: the impersonation index re-exports install.ts, which imports
// features/auth — importing it here would create a module cycle. urlSync is standalone.
import { appendImpersonateQuery, persistStickyImpersonateEmail, resolveRequestedImpersonateEmail, } from 'features/impersonation/urlSync';
import { ExchangeError } from '../ports/exchange';
function postExchange(url, firebaseIdToken) {
    return fetch(url, {
        method: 'POST',
        headers: {
            'X-Api-Key': SERVER_API.xApiKey,
            'Content-Type': SERVER_API.contentType,
        },
        body: JSON.stringify({
            scope: SERVER_API.scope,
            idToken: firebaseIdToken,
        }),
    });
}
export function createFetchExchangeAdapter() {
    return {
        async exchange(firebaseIdToken) {
            // ROWILABDEV-72: the exchange IS the API root query, so impersonation must be
            // applied here for `subject` and root potentialActions to describe the
            // impersonated user.
            const requested = resolveRequestedImpersonateEmail();
            if (requested) {
                // The API rejects (HTTP 500) impersonation it won't honor — non-admin caller or
                // invalid target — rather than ignoring the param. A failed impersonated
                // exchange must therefore drop the sticky value and fall through to a clean
                // exchange, or a leftover value would lock the user out on every reload.
                try {
                    const response = await postExchange(appendImpersonateQuery(SERVER_API.url, requested), firebaseIdToken);
                    if (response.ok) {
                        return response.json();
                    }
                }
                catch {
                    // Network failure — clear and fall through; the clean attempt will surface it.
                }
                persistStickyImpersonateEmail('');
            }
            let response;
            try {
                response = await postExchange(SERVER_API.url, firebaseIdToken);
            }
            catch (cause) {
                throw new ExchangeError({ kind: 'network' });
            }
            if (!response.ok) {
                const status = response.status;
                if (status === 404 || status === 410) {
                    throw new ExchangeError({ kind: 'deleted' });
                }
                if (status === 403 || status === 423) {
                    throw new ExchangeError({ kind: 'inactive' });
                }
                throw new ExchangeError({ kind: 'unexpected', status });
            }
            return response.json();
        },
    };
}
